import { Link } from "react-router-dom";
import { ProductData } from "../types/product";
import { ArrowBigRight } from "lucide-react";
import { strategy as unitForQuantityStrategy } from "@/common/constants/unitForQuantityOptions";
import Button from "../../../common/components/Button";

export class ProductsTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (products: ProductData[]) => {
      return products.map((product) => ({
        ...product,
        categoryName: product?.category?.display_name,
        tef_identifiers:
          product?.product_tef_identifiers?.reduce(
            (acc, curr) => (acc ? acc + ', ' + curr.identifier : curr.identifier),
            '',
          ) || '',
        unit_for_quantity: unitForQuantityStrategy[product.unit_for_quantity as keyof typeof unitForQuantityStrategy],
        actions: <Link to={`/products/${product.id}`} className="cursor-pointer">
          <Button name="access_products_list" className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
            <ArrowBigRight />
          </Button>
        </Link>
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (products: ProductData[]) => {
      return products.map((product) => ({
        route: `/products/${product.id}`,
        items: [
          ['Categoria', product?.category?.display_name],
          ['Nome', product.display_name],
          ['Unidade', unitForQuantityStrategy[product.unit_for_quantity as keyof typeof unitForQuantityStrategy]],
        ]
      }));
    };
  }
}
